import { clamp, formatTime } from '../core/vec';
import type { Engine } from '../game/engine';

interface HudElements {
  hpFill: HTMLElement;
  hpText: HTMLElement;
  xpFill: HTMLElement;
  timer: HTMLElement;
  level: HTMLElement;
  kills: HTMLElement;
  gold: HTMLElement;
  bossBar: HTMLElement;
  bossName: HTMLElement;
  bossFill: HTMLElement;
  root: HTMLElement;
}

export class Hud {
  private tick = 0;

  constructor(private els: HudElements) {}

  show(): void {
    this.els.root.classList.remove('hidden');
  }

  hide(): void {
    this.els.root.classList.add('hidden');
  }

  /** DOM 写入节流到 20Hz（每 3 个逻辑步），减少移动端样式计算。 */
  update(engine: Engine): void {
    this.tick++;
    if (this.tick % 3 !== 0) return;
    const p = engine.player;
    const hpRatio = clamp(p.hp / p.stats.maxHp, 0, 1);
    this.els.hpFill.style.width = `${hpRatio * 100}%`;
    this.els.hpText.textContent = `${Math.max(0, Math.ceil(p.hp))}/${p.stats.maxHp}`;

    const xpRatio = clamp(p.xp / p.xpToNext, 0, 1);
    this.els.xpFill.style.width = `${xpRatio * 100}%`;

    this.els.timer.textContent = formatTime(engine.time);
    this.els.level.textContent = String(p.level);
    this.els.kills.textContent = String(engine.kills);
    this.els.gold.textContent = String(engine.gold);
    this.updateBoss(engine);
  }

  private updateBoss(engine: Engine): void {
    let boss = null;
    for (const e of engine.enemyPool.all()) {
      if (e.active && (e.kind === 'boss1' || e.kind === 'boss2')) {
        boss = e;
        break;
      }
    }
    if (!boss) {
      this.els.bossBar.classList.add('hidden');
      return;
    }
    this.els.bossBar.classList.remove('hidden');
    this.els.bossName.textContent = boss.kind === 'boss1' ? 'BOSS Ⅰ' : '终 BOSS';
    const ratio = clamp(boss.hp / boss.maxHp, 0, 1);
    this.els.bossFill.style.width = `${ratio * 100}%`;
  }
}
